<template>
  <div></div>
</template>

<script>
// import { saveUserInfo } from '@/api/user';

export default {
  name: 'manualCustomer',
  data () {
    return {
      clickSwitch: false
    };
  },
  created() {
  },
  mounted() {
    this.insert53Code()
  },
  methods: {
    async insert53Code() {
      const { account, game, server, role_name,appkey  } = this.$route.query
      // if (account) {
      //   await saveUserInfo({
      //     account: account,
      //     game: game,
      //     game_server: server || '',
      //     role_name: role_name || ''
      //   })
      // }
      let _53code = document.createElement('script');
      let id = Math.floor(Math.random() * (1000000000 - 100000000 + 1)) + 100000000
      
      // let src = '{*53客服域名*}';
      // if (account) {
      //   src = `${src}?u_cust_id=${account}&u_cust_name=${account}`;
      // } else {
      //   this.$router.push({ query: {} });
      //   src = `${src}?u_cust_id=${id}&u_cust_name=公众号来访`;
      // }
      // _53code.src = src;
      // _53code.async = 'async';
      // let s = document.getElementsByTagName('script')[0];
      // s.parentNode.insertBefore(_53code, s);

      // let src = 'https://wpa1.qq.com/pozYGuf4?_type=wpa&qidian=true';
      let src = 'https://wpa1.qq.com/4et3XbnQ?_type=wpa&qidian=true';
      if(appkey == 200025297 || appkey == 200025295 || appkey == 200024951){
        src = 'https://wpa1.qq.com/vFof0hZw?_type=wpa&qidian=true';
      }else if(appkey == 200024245){
        src = 'https://wpa1.qq.com/n4p9DDkK?_type=wpa&qidian=true';
      }
      if (account) {
        src = `${src}&u_cust_id=${account}&u_cust_name=${account}`;
      } else {
        this.$router.push({ query: {} });
        src = `${src}&u_cust_id=${id}&u_cust_name=公众号来访`;
      }
      window.location.href = src;
    },
  }
}
</script>